<template>
    <section>
        <div class="left">
            <h2>{{ title }}</h2>
        </div>

        <div class="right checkbox_group">
            <div class="field_left" v-if="!isSystem">
                <p class="field">
                    <label :for="'vyhledavani_' + (sortable ? 'yes' : 'no')"  v-translate>Omezení výběru na</label>
                    <input :id="'vyhledavani_' + (sortable ? 'yes' : 'no')" class="search" name="'vyhledavani_' + (sortable ? 'yes' : 'no')" size="30" type="text"
                       v-model="searchText"
                       :placeholder="$gettext('Např. Prima')"
                    />
                    <a :style="clearButtonStyle" id="vyhledavani_delete" class="clearable_btn" @click.stop="clearSearchText" :title="$gettext('Vymazat text')">{{ $gettext('Vymazat') }}</a>
                </p>
            </div>

            <p class="check_all" v-if="!this.searchText && !isSystem">
                <input :id="'checkAll_' + (sortable ? 'yes' : 'no')" @click.stop="selectAllChannels" :name="'checkAll_' + (sortable ? 'yes' : 'no')" type="checkbox" value="false" :checked="this.checkedAll">
                <label :for="'checkAll_' + (sortable ? 'yes' : 'no')" v-translate>Označit vše</label>
            </p>

            <p class="btn_right" v-if="!isSystem">
                <input @click.stop="_doAction" class="btn" :class="{btn_inactive: selectedChannelIds.length === 0}" type="submit" :value="$gettext(this.actionButtonTitle)">
            </p>

            <ul v-if="!sortable || this.searchText">
                <li v-for="channel in sortedChannelList" :key="channel.id">
                    <input :id="'channel_'+channel.id" :name="'channel_'+channel.id" type="checkbox" :value="channel.id" v-model="selectedChannelIds" />
                    <label :for="'channel_'+channel.id">{{ channel.name }} <span class="stitek" v-if="channel.hd">HD</span></label>
                </li>
            </ul>
            <ol :class="[{'sortable': $_updateActionAllowed}]" id="sortable" v-else>
                <li v-for="channel in channelList" :key="channel.id" class="sortedChannels" :channelId="channel.id">
                    <input v-if="!isSystem" :id="'channel_'+channel.id" :name="'channel_'+channel.id" type="checkbox" :value="channel.id" v-model="selectedChannelIds" />
                    <label :for="'channel_'+channel.id">{{ channel.name }} <channel-video-quality-label :quality="channel.video_quality"></channel-video-quality-label></label>
                </li>
            </ol>
        </div>
    </section>
</template>

<script>
import ChannelVideoQualityLabel from "../../../common/ChannelVideoQualityLabel";

export default {
    name: "ChannelList",
    components: {ChannelVideoQualityLabel},
    props: ["channelIds", "allChannels", "title", "actionButtonTitle", "sortable", "isSystem"],
    data() {
        return {
            selectedChannelIds: [],
            checkedAll: false,
            searchText: '',
            sortingEnabled: false,
        }
    },
    methods: {
        selectAllChannels() {
            this.checkedAll = !this.checkedAll;

            if (this.checkedAll) {
                this.selectedChannelIds = [...this.channelIds];
            } else {
                this.selectedChannelIds = [];
            }
        },
        clearSearchText() {
            this.searchText = '';
        },
        _doAction() {
          if(this.$_updateActionAllowed) {
            if (this.selectedChannelIds.length > 0) {
              this.$emit('buttonClick', [...this.selectedChannelIds]);
              this.selectedChannelIds = [];
              this.checkedAll = false;
            }
          }
        },
        _allowSorting() {
          if(this.$_updateActionAllowed) {
            $("#sortable").sortable({
              stop: this._sortEntity,
            });

            this.sortingEnabled = true;
          }
        },
        _sortEntity() {
            let sortedChannels = [];

            $(".sortedChannels").each(function () {
                sortedChannels.push(~~$(this).attr('channelId'));
            });

            this.$emit('sorted', [...sortedChannels]);
        }
    },
    mounted() {
        if (this.sortable) {
            this._allowSorting();
        }
    },
    updated() {
        if (this.sortable && $("#sortable").length > 0 && !this.sortingEnabled) {
            this._allowSorting();
        }
    },
    computed: {
        clearButtonStyle() {
            if (this.searchText === '') {
                return 'display: none'
            } else {
                return 'display: inline'
            }
        },
        channelList() {
            let channels = [];
            this.channelIds.forEach((channelId) => {
              if(this.allChannels.hasOwnProperty(channelId)) {
                var channel = this.allChannels[channelId];

                if (!this.searchText || channel.name.toLowerCase().includes(this.searchText.toLowerCase())) {
                  channels.push(this.allChannels[channelId]);
                }
              }
            });

            return channels;
        },
        sortedChannelList() {
            let channels = this.channelList;

            channels.sort((channelA, channelB) => {
                return channelA.name.toLowerCase().localeCompare(channelB.name.toLowerCase());
            })

            return channels;
        }
    },
    watch: {
        'searchText' (newValue) {
            if (newValue != '') {
                this.sortingEnabled = false;
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/views/channelGroups/detail/channelList.vue